<template>
  <md-field md-clearable @md-clear="clearValue" class="md-invalid date-picker">
    <div class="w-full relative cursor-pointer">
      <div class="w-full h-full flex">
        <label>{{ $t(label) }}</label>
        <md-input
          :disabled="disabled"
          v-model="datePicker"
          :required="required"
          readonly
        ></md-input>
        <slot></slot>
      </div>
      <date-picker
        :disabled="disabled"
        :disabled-date="disabledDate"
        v-model="datePicker"
        type="date"
        :format="formatDateClient"
        value-type="format"
        @change="changeValue($event)"
        ref="datePicker"
      ></date-picker>
    </div>
  </md-field>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  convertDateFromServer,
  convertDateSendServer,
  formatDateClient
} from "@/helpers/datetime-helper";

export default {
  name: "date-picker-custom",
  components: { DatePicker },
  props: {
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    value: String,
    disabled: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: () => {}
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      formatDateClient
    };
  },
  computed: {
    datePicker: {
      get: function() {
        return convertDateFromServer(this.value, "date");
      },
      set: function(value) {
        return value;
      }
    }
  },
  methods: {
    changeValue(newValue) {
      if (newValue) {
        const dateSendServer = convertDateSendServer(newValue, "date");
        this.$emit("change", dateSendServer);
      } else {
        this.clearValue();
      }
    },
    clearValue() {
      this.datePicker = "";
      this.$emit("change", "");
    }
  }
};
</script>
<style lang="scss">
.date-picker {
  .mx-datepicker {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;

    input.mx-input {
      background: transparent;
      border: 0;
      box-shadow: none;
      color: transparent;
      cursor: pointer;
    }
    .mx-icon-clear {
      color: transparent;
    }
  }

  .md-error {
    top: 35px;
  }

  button[disabled="disabled"].md-clear {
    display: none;
  }
}
</style>
